interface GameControlsProps {
  onMoveLeft: () => void;
  onMoveRight: () => void;
  onStop: () => void;
  showMobileControls?: boolean;
  speed: number;
  onSpeedChange: (speed: number) => void;
}

const GameControls = ({
  onMoveLeft,
  onMoveRight,
  onStop,
  showMobileControls = false,
  speed,
  onSpeedChange,
}: GameControlsProps) => {
  return (
    <>
      {/* Instructions bar at bottom */}
      <div className="bg-gray-800 text-white py-3 px-4 flex justify-center items-center gap-6 text-base flex-wrap">
        <div className="flex items-center gap-2">
          <span className="inline-flex gap-1">
            <kbd className="px-2 py-1 bg-gray-700 rounded text-sm font-mono">&larr;</kbd>
            <kbd className="px-2 py-1 bg-gray-700 rounded text-sm font-mono">&rarr;</kbd>
          </span>
          <span className="text-gray-300">Move</span>
        </div>
        <div className="flex items-center gap-2">
          <kbd className="px-2 py-1 bg-gray-700 rounded text-sm font-mono">&uarr;</kbd>
          <span className="text-gray-300">Top building</span>
        </div>
        <div className="flex items-center gap-2">
          <kbd className="px-2 py-1 bg-gray-700 rounded text-sm font-mono">&darr;</kbd>
          <span className="text-gray-300">Bottom building</span>
        </div>
        <div className="flex items-center gap-2">
          <kbd className="px-2 py-1 bg-gray-700 rounded text-sm font-mono">ESC</kbd>
          <span className="text-gray-300">Close</span>
        </div>

        {/* Speed toggle */}
        <div className="flex items-center gap-2 ml-4 border-l border-gray-600 pl-4">
          <span className="text-gray-300 mr-2">Speed:</span>
          {[1, 2, 3].map((s) => (
            <button
              key={s}
              onClick={() => onSpeedChange(s)}
              className={`px-3 py-1 rounded text-sm font-bold transition-colors ${
                speed === s
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
              }`}
            >
              {s}x
            </button>
          ))}
        </div>
      </div>

      {/* Mobile touch controls */}
      {showMobileControls && (
        <div className="md:hidden flex justify-center gap-4 py-4 bg-gray-100">
          <button
            className="w-16 h-16 bg-gray-700 text-white rounded-full text-2xl active:bg-gray-600 touch-manipulation"
            onTouchStart={(e) => {
              e.preventDefault();
              onMoveLeft();
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              onStop();
            }}
            onMouseDown={onMoveLeft}
            onMouseUp={onStop}
            onMouseLeave={onStop}
          >
            &larr;
          </button>
          <button
            className="w-16 h-16 bg-gray-700 text-white rounded-full text-2xl active:bg-gray-600 touch-manipulation"
            onTouchStart={(e) => {
              e.preventDefault();
              onMoveRight();
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              onStop();
            }}
            onMouseDown={onMoveRight}
            onMouseUp={onStop}
            onMouseLeave={onStop}
          >
            &rarr;
          </button>
        </div>
      )}
    </>
  );
};

export default GameControls;
